import { FC, lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router';
import LogoutWrapper from './LogoutWrapper';
import Loading from './components/loading/Loading';
import './styles/themes/opxp/theme.scss';

const subscribeWidget = lazy(() => import('./widgets/subscribe'));
const OpxpRegistration = lazy(() => import('./apps/opxpSignup/OpxpRegistration'));
const OpxpLogin = lazy(() => import('./apps/opxpLogin/OpxpLogin'));
const OpxpPasswordForgot = lazy(() => import('./apps/opxpForgot/OpxpForgotApp'));
const OpxpPasswordApp = lazy(() => import('./apps/opxpPassword/OpxpPasswordApp'));
const LogoutApp = lazy(() => import('./apps/logout/LogoutApp'));
const MobilePageApp = lazy(() => import('./apps/mobilePage'));
const CouponApp = lazy(() => import('./apps/coupon'));
const LogoutDiscountApp = lazy(() => import('./apps/logoutDiscount'));

export const Root: FC = () => {
  return (
    <Suspense fallback={<Loading />}>
      <LogoutWrapper />
      <Routes>
        <Route path="/subscribe" Component={subscribeWidget} />
        <Route path="/coupon" Component={CouponApp} />
        <Route path="/logoutDiscount" Component={LogoutDiscountApp} />
        <Route path="/opxp?/signup/*" Component={OpxpRegistration} />
        <Route path="/opxp/login" Component={OpxpLogin} />
        <Route path="/opxp?/forgot" Component={OpxpPasswordForgot} />
        <Route path="/opxp?/password" Component={OpxpPasswordApp} />
        <Route path="/opxp?/logout/:mode?" Component={LogoutApp} />
        <Route path="/mobile/:page" Component={MobilePageApp} />
        <Route path="/" Component={OpxpLogin} />
      </Routes>
    </Suspense>
  );
};

export default Root;
